// import React from "react";

// const Banner = (props) => {
//   return (
//     <div className="bg-black text-white py-16 ">
//       <div className="container mx-auto max-w-[80rem] text-center px-4">
//         {/* <h1 className="text-4xl md:text-5xl font-bold mb-4">ALL AI TOOLS</h1> */}
//         <h1 className="text-4xl md:text-5xl font-bold mb-4 bg-[linear-gradient(45deg,_#00bf67,_#0068ff)] bg-clip-text text-transparent inline">{props.title}</h1>
//         {/* <p className="text-lg md:text-xl font-medium">
//           Discover the Best AI Tools Categories to Transform Your Workflow
//         </p> */}
//         <p className="text-lg md:text-xl font-medium">
//           {props.para}
//         </p>
//       </div>
//     </div>
//   );
// };

// export default Banner;


import React from "react";

const Banner = (props) => {
  return (
    <div className="bg-black text-white py-16 pb-10">
      <div className="container mx-auto max-w-[80rem] text-center px-4">
        {/* <h1 className="text-4xl md:text-5xl font-bold mb-4">ALL AI TOOLS</h1> */}
        <h1 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-[#ffffff] via-[#f55fff] to-[#0047FF] bg-clip-text text-transparent inline">{props.title}</h1>
        {/* <p className="text-lg md:text-xl font-medium">
          Discover the Best AI Tools Categories to Transform Your Workflow
        </p> */}
        <p className="text-lg md:text-xl font-medium mt-1">
          {props.para}
        </p>
      </div>
    </div>
  );
};

export default Banner;  
